import "./index.scss";
import { useEffect, useRef, useState } from "react";
import { ReactComponent as SearchIcon } from "assets/search.svg";
import { SearchBrandsInput } from "components/UI/molecules";
import { SearchBrandsDropdown } from "../search-brands-dropdown";
import { Button } from "components/UI/atoms";
import { useWindowDimensions } from "hooks/useWindowDimensions";

export const NavbarSearch = ({ brands, onBrandsChange }) => {
  const [isOpen, setOpen] = useState(false);
  const [dropdown, setDropdown] = useState(false);
  const { width } = useWindowDimensions();
  const inputRef = useRef(null);

  const handleButtonClick = () => {
    setOpen(true);
  };

  const handleInputBlur = () => {
    setOpen(false);
  };

  const isMobile = width <= 768;

  useEffect(() => {
    if (inputRef.current && isOpen) {
      inputRef.current.focus();
    }
  }, [isOpen]);

  return (
    <div className="search-container">
      {isMobile && !isOpen && (
        <Button
          onClick={handleButtonClick}
          variant="outline"
          customClassName="button-search-icon"
        >
          <SearchIcon className="search-icon" />
        </Button>
      )}
      {((isMobile && isOpen) || !isMobile) && (
        <>
          <SearchBrandsInput
            variant="navbar"
            placeholder="Search"
            onBrandsChange={onBrandsChange}
            shouldShowDropdown={(value) => setDropdown(value)}
            onInputBlur={handleInputBlur}
            ref={inputRef}
          />
          <div className="dropdown-container">
            <SearchBrandsDropdown canShowDropdown={dropdown} brands={brands} />
          </div>
        </>
      )}
    </div>
  );
};
